<div class="about">
  <img class="logo" src="/assets/images/Virena_System.png">
  <div>Version: {{applicationVersion}}</div>
  <a *ngIf="showLicensesLink" href="./3rdpartylicenses.txt" target="_blank">Licenses</a>
  <div>&copy; QuidelOrtho Corporation {{currentDate | date: yearFormat}}</div>
</div>
